"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

var _this = this;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NGL = require("ngl");

var data_1 = require("../data");

var helper_1 = require("./");

exports.fetchAppropriateData = function (viz, dataDir) {
  return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (viz) {
        case data_1.VIZ_TYPE['T-SNE']:
        case data_1.VIZ_TYPE['T-SNE-FRAME']:
          return [2
          /*return*/
          , exports.fetchTSneCoordinateData(dataDir)];

        case data_1.VIZ_TYPE['TENSOR-T-SNE']:
          return [2
          /*return*/
          , exports.fetchTensorTSneCoordinateData(dataDir)];

        case data_1.VIZ_TYPE.SPRING:
          return [2
          /*return*/
          , exports.fetchSpringData(dataDir)];

        case data_1.VIZ_TYPE.NGL:
          return [2
          /*return*/
          , exports.fetchNGLDataFromDirectory(dataDir)];

        case data_1.VIZ_TYPE.CONTACT_MAP:
        case data_1.VIZ_TYPE.INFO_PANEL:
          return [2
          /*return*/
          , exports.fetchContactMapData(dataDir)];

        default:
          return [2
          /*return*/
          , Promise.reject({
            error: "Currently no appropriate data getter for " + viz
          })];
      }

      return [2
      /*return*/
      ];
    });
  });
};

exports.fetchAppropriateDataFromFile = function (viz, file) {
  return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, _c;

    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          _a = viz;

          switch (_a) {
            case data_1.VIZ_TYPE.NGL:
              return [3
              /*break*/
              , 1];

            case data_1.VIZ_TYPE.CONTACT_MAP:
              return [3
              /*break*/
              , 2];
          }

          return [3
          /*break*/
          , 4];

        case 1:
          return [2
          /*return*/
          , exports.fetchNGLDataFromFile(file)];

        case 2:
          _b = {};
          _c = exports.getCouplingScoresData;
          return [4
          /*yield*/
          , helper_1.readFileAsText(file)];

        case 3:
          return [2
          /*return*/
          , (_b.couplingScores = _c.apply(void 0, [_d.sent()]), _b)];

        case 4:
          return [2
          /*return*/
          , Promise.reject({
            error: "Currently no appropriate data getter for " + viz + " files"
          })];
      }
    });
  });
};

exports.fetchSpringData = function (dataDir) {
  return __awaiter(_this, void 0, void 0, function () {
    var catColorData, nodes, categories;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , fetchCategoricalColorData(dataDir + "/categorical_coloring_data.json")];

        case 1:
          catColorData = _a.sent();
          nodes = new Array();
          categories = Object.keys(catColorData);
          catColorData[categories[0]].label_list.forEach(function (label, index) {
            nodes.push({
              labelForCategory: categories.reduce(function (prev, category) {
                var _a;

                return __assign({}, prev, (_a = {}, _a[category] = catColorData[category].label_list[index], _a));
              }, {}),
              number: index
            });
          });
          return [2
          /*return*/
          , {
            nodes: nodes
          }];
      }
    });
  });
};

var fetchCategoricalColorData = function fetchCategoricalColorData(file) {
  return __awaiter(_this, void 0, void 0, function () {
    var e_1, _a, e_2, _b, input, result, _c, _d, key, colorData, output, label_colors, _e, _f, labelColorKey, hex;

    return __generator(this, function (_g) {
      switch (_g.label) {
        case 0:
          return [4
          /*yield*/
          , helper_1.fetchJSONFile(file)];

        case 1:
          input = _g.sent();
          result = {};

          try {
            for (_c = __values(Object.keys(input)), _d = _c.next(); !_d.done; _d = _c.next()) {
              key = _d.value;
              colorData = input[key];

              if (!colorData.label_colors || !colorData.label_list) {
                throw new Error("Unable to parse color data - does it have keys named 'label_colors' and 'label_list'");
              }

              output = {
                label_colors: {},
                label_list: colorData.label_list
              };
              label_colors = input[Object.keys(input)[0]].label_colors;

              try {
                // The input file might specify hex values as either 0xrrggbb or #rrggbb, so we need to convert the input to a consistent output format.
                for (_e = __values(Object.keys(label_colors)), _f = _e.next(); !_f.done; _f = _e.next()) {
                  labelColorKey = _f.value;
                  hex = label_colors[labelColorKey];

                  if (typeof hex === 'number') {
                    output.label_colors[labelColorKey] = hex;
                  } else if (hex.charAt(0) === '#') {
                    output.label_colors[labelColorKey] = Number.parseInt("0x" + hex.slice(1), 16);
                  } else {
                    output.label_colors[labelColorKey] = Number.parseInt(hex, 16);
                  }
                }
              } catch (e_2_1) {
                e_2 = {
                  error: e_2_1
                };
              } finally {
                try {
                  if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally {
                  if (e_2) throw e_2.error;
                }
              }

              result[key] = output;
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally {
              if (e_1) throw e_1.error;
            }
          }

          return [2
          /*return*/
          , result];
      }
    });
  });
};

exports.fetchSpringCoordinateData = function (file) {
  return __awaiter(_this, void 0, void 0, function () {
    var coordinateText, coordinates, rows;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , helper_1.fetchCSVFile(file)];

        case 1:
          coordinateText = _a.sent();
          coordinates = [];
          rows = coordinateText ? coordinateText.split('\n') : [];
          rows.forEach(function (entry, index, array) {
            var items = entry.split(',');

            if (items.length >= 3) {
              var xx = parseFloat(items[1].trim());
              var yy = parseFloat(items[2].trim());
              var nn = parseInt(items[0].trim(), 10);
              coordinates[nn] = [xx, yy];
            } else if (entry.localeCompare('') !== 0) {
              throw new Error("Unable to parse coordinate data - Row " + index + " does not have at least 3 columns!");
            }
          });
          return [2
          /*return*/
          , coordinates];
      }
    });
  });
};

exports.fetchTSneCoordinateData = function (dataDir) {
  return __awaiter(_this, void 0, void 0, function () {
    var coordText, result;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , helper_1.fetchCSVFile(dataDir + "/tsne_output.csv")];

        case 1:
          coordText = _a.sent();
          result = [];
          coordText.split('\n').forEach(function (entry) {
            if (entry.length > 0) {
              var items = entry.split(',');
              var coordinates = [parseFloat(items[0]), parseFloat(items[1])];
              result.push(coordinates);
            }
          });
          return [2
          /*return*/
          , result];
      }
    });
  });
};

exports.fetchTensorTSneCoordinateDataFromFile = function (fileLocation) {
  return __awaiter(_this, void 0, void 0, function () {
    var e_3, _a, coordText, matrix, _b, _c, row;

    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          return [4
          /*yield*/
          , helper_1.fetchCSVFile(fileLocation)];

        case 1:
          coordText = _d.sent();
          matrix = new Array();

          try {
            for (_b = __values(coordText.split('\n')), _c = _b.next(); !_c.done; _c = _b.next()) {
              row = _c.value;

              if (row.length >= 1) {
                matrix.push(row.split(',').map(parseFloat));
              }
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
              if (e_3) throw e_3.error;
            }
          }

          return [2
          /*return*/
          , matrix];
      }
    });
  });
};

exports.fetchTensorTSneCoordinateData = function (dataDir) {
  return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , exports.fetchTensorTSneCoordinateDataFromFile(dataDir + "/tsne_matrix.csv")];
    });
  });
};

exports.fetchGraphData = function (file) {
  return __awaiter(_this, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , helper_1.fetchJSONFile(file)];

        case 1:
          data = _a.sent();

          if (!data.nodes || !data.links) {
            throw new Error("Unable to parse graph data - does it have keys named 'nodes' and 'links'");
          }

          return [2
          /*return*/
          , data];
      }
    });
  });
};

exports.fetchNGLDataFromDirectory = function (dir) {
  return __awaiter(_this, void 0, void 0, function () {
    var file;
    return __generator(this, function (_a) {
      if (dir.length === 0) {
        return [2
        /*return*/
        , Promise.reject('Empty path.')];
      }

      file = dir + "/protein.pdb";
      return [2
      /*return*/
      , exports.fetchNGLDataFromFile(file)];
    });
  });
};

exports.fetchNGLDataFromFile = function (file, params) {
  if (params === void 0) {
    params = {};
  }

  return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , NGL.autoLoad(file, params)];

        case 1:
          return [2
          /*return*/
          , _a.sent()];
      }
    });
  });
};

exports.fetchContactMapData = function (dir) {
  return __awaiter(_this, void 0, void 0, function () {
    var contactMapFiles, promiseResults, pdbData;

    var _this = this;

    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (dir.length === 0) {
            return [2
            /*return*/
            , Promise.reject('Empty path.')];
          }

          contactMapFiles = ['coupling_scores.csv', 'residue_mapping.csv'];
          return [4
          /*yield*/
          , Promise.all(contactMapFiles.map(function (file) {
            return __awaiter(_this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                return [2
                /*return*/
                , helper_1.fetchCSVFile(dir + "/" + file)];
              });
            });
          }))];

        case 1:
          promiseResults = _a.sent();
          return [4
          /*yield*/
          , data_1.ChellPDB.createPDB(dir + "/protein.pdb")];

        case 2:
          pdbData = _a.sent();
          return [2
          /*return*/
          , {
            couplingScores: exports.getCouplingScoresData(promiseResults[0], helper_1.generateResidueMapping(promiseResults[1])),
            pdbData: pdbData,
            secondaryStructures: []
          }];
      }
    });
  });
};
/**
 * Parses a coupling_scores.csv file to generate the appropriate data structure.
 *
 * !Important!
 * Currently 12 fields are assumed to be part of a single coupling score.
 * As such, any rows with less will be ignored.
 *
 * @param line The csv file as a single string.
 * @param residueMapping Maps the coupling_score.csv residue number to the residue number for the PDB.
 * @returns Array of CouplingScores suitable for chell-viz consumption.
 */


exports.getCouplingScoresData = function (line, residueMapping) {
  if (residueMapping === void 0) {
    residueMapping = [];
  }

  var headerRow = line.split('\n')[0].split(',');
  var isHeaderPresent = isCouplingHeaderPresent(headerRow);
  var headerIndices = helper_1.getCouplingHeaderIndices(headerRow, isHeaderPresent);
  var couplingScores = new data_1.CouplingContainer();
  line.split('\n').slice(isHeaderPresent ? 1 : 0).filter(function (row) {
    return row.split(',').length >= 2;
  }).map(function (row) {
    var items = row.split(',');
    var score = getCouplingScoreFromCSVRow(items, headerIndices);

    if (residueMapping.length >= 1) {
      var mappingIndexI = residueMapping.findIndex(function (mapping) {
        return mapping.couplingsResno === score.i;
      });
      var mappingIndexJ = residueMapping.findIndex(function (mapping) {
        return mapping.couplingsResno === score.j;
      });
      couplingScores.addCouplingScore(__assign({}, score, {
        A_i: residueMapping[mappingIndexI].pdbResCode,
        A_j: residueMapping[mappingIndexJ].pdbResCode,
        i: residueMapping[mappingIndexI].pdbResno,
        j: residueMapping[mappingIndexJ].pdbResno
      }));
    } else {
      couplingScores.addCouplingScore(score);
    }
  });
  return couplingScores;
};

var isCouplingHeaderPresent = function isCouplingHeaderPresent(headerRow) {
  return ['cn', 'dist', 'i', 'j'].filter(function (row) {
    return headerRow.includes(row);
  }).length >= 1;
};

var getCouplingScoreFromCSVRow = function getCouplingScoreFromCSVRow(row, headerIndices) {
  return Object.entries(headerIndices).reduce(function (prev, headerName) {
    var _a;

    var couplingKey = headerName[0];
    var couplingKeyIndex = headerName[1];
    return __assign({}, prev, (_a = {}, _a[couplingKey] = isNaN(Number(row[couplingKeyIndex])) ? row[couplingKeyIndex] : Number(row[couplingKeyIndex]), _a));
  }, {
    i: -1,
    j: -1
  });
};

exports.augmentCouplingScoresWithResidueMapping = function (couplingScores, residueMapping) {
  if (residueMapping === void 0) {
    residueMapping = [];
  }

  var e_4, _a;

  var result = new data_1.CouplingContainer();

  var _loop_1 = function _loop_1(score) {
    var mappedIndexI = residueMapping.findIndex(function (mapping) {
      return mapping.couplingsResno === score.i;
    });
    var mappedIndexJ = residueMapping.findIndex(function (mapping) {
      return mapping.couplingsResno === score.j;
    });
    result.addCouplingScore({
      A_i: residueMapping[mappedIndexI].pdbResCode,
      A_j: residueMapping[mappedIndexJ].pdbResCode,
      cn: score.cn,
      dist: score.dist,
      i: residueMapping[mappedIndexI].pdbResno,
      j: residueMapping[mappedIndexJ].pdbResno
    });
  };

  try {
    for (var couplingScores_1 = __values(couplingScores), couplingScores_1_1 = couplingScores_1.next(); !couplingScores_1_1.done; couplingScores_1_1 = couplingScores_1.next()) {
      var score = couplingScores_1_1.value;

      _loop_1(score);
    }
  } catch (e_4_1) {
    e_4 = {
      error: e_4_1
    };
  } finally {
    try {
      if (couplingScores_1_1 && !couplingScores_1_1.done && (_a = couplingScores_1.return)) _a.call(couplingScores_1);
    } finally {
      if (e_4) throw e_4.error;
    }
  }

  return result;
};
/**
 * Parses a distance_map.csv file to generate the appropriate secondary structure mapping.
 *
 * !Important!
 * The first line in the csv will be ignored as it is assumed to be a csv header.
 *
 * !Important!
 * Currently 3 fields are assumed to be part of a single entry, with the second and third actually being relevant.
 * As such, any other rows will be ignored.
 *
 * @param line The csv file as a single string.
 * @returns Array of SecondaryStructure mappings suitable for chell-viz consumption.
 */


exports.getSecondaryStructureData = function (line) {
  return line.split('\n').slice(1).filter(function (row) {
    return row.split(',').length >= 3;
  }).map(function (row) {
    var items = row.split(',');
    return {
      resno: parseFloat(items[1]),
      structId: items[2]
    };
  });
};
/*
TODO Currently not being used by Spring. Remove? Use in future Spring work?
export const fetchColorData = async (file: string) => {
  const colorText: string = await fetchCSVFile(file);
  const dict: { [k: string]: any } = {};
  colorText.split('\n').forEach((entry, index, array) => {
    if (entry.length > 0) {
      const items = entry.split(',');
      const gene = items[0];
      const expArray: any[] = [];
      items.forEach((e, i, a) => {
        if (i > 0) {
          expArray.push(parseFloat(e));
        }
      });
      dict[gene] = expArray;
    }
  });
  return dict;
};
*/